import { render } from "./Contact.vue?vue&type=template&id=f8ef3c88&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=f8ef3c88&scoped=true&lang=css"

import exportComponent from "D:\\GIT\\TaleMakerWeb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8ef3c88"]])

export default __exports__